module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("Cargar HES / MIGO")])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "mobile",
    attrs: {
      "title": "Cargar datos de operación",
      "visible": _vm.showModal,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      }
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "-20px",
      "font-weight": "300"
    }
  }, [_vm._v("Datos de la operación")]), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-form', {
    ref: "formRef",
    attrs: {
      "model": _vm.document,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    staticClass: "form-select",
    attrs: {
      "size": "small",
      "label": "Tipo de operación*"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Tipo de operación"
    },
    model: {
      value: (_vm.document.ocType),
      callback: function($$v) {
        _vm.$set(_vm.document, "ocType", $$v)
      },
      expression: "document.ocType"
    }
  }, _vm._l((_vm.acceptanceType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.document.ocType === '1') ? _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "size": "small"
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "input-view1-text",
    attrs: {
      "span": 12
    }
  }, [_vm._v("\n                        Agregar HES\n                    ")]), _vm._v(" "), _c('el-col', {
    staticClass: "input-view2",
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "-10px"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.addOcNumber
    }
  }, [_vm._v("+")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.document.ocType === '1') ? _c('el-divider') : _vm._e(), _vm._v(" "), _vm._l((_vm.document.hesNumbers), function(ocNumber, index) {
    return (_vm.document.ocType === '1') ? _c('el-form-item', {
      key: index,
      staticClass: "form-input",
      attrs: {
        "size": "small"
      }
    }, [_c('el-row', {
      staticStyle: {
        "margin-bottom": "10px",
        "margin-left": "-100px"
      },
      attrs: {
        "span": 24
      }
    }, [_c('b', [_vm._v("Carga de HES " + _vm._s(index + 1))])]), _vm._v(" "), _c('el-row', [_c('el-col', {
      staticClass: "input-view1",
      staticStyle: {
        "margin-left": "-120px"
      },
      attrs: {
        "span": 12
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Numero de HES*"
      },
      model: {
        value: (_vm.document.hesNumbers[index]),
        callback: function($$v) {
          _vm.$set(_vm.document.hesNumbers, index, $$v)
        },
        expression: "document.hesNumbers[index]"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticClass: "input-view2",
      attrs: {
        "span": 12
      }
    }, [_c('el-button', {
      staticStyle: {
        "margin-left": "35px"
      },
      attrs: {
        "type": "warning"
      },
      on: {
        "click": function($event) {
          return _vm.deleteOcNumber(index)
        }
      }
    }, [_vm._v("-")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-row', {
      staticStyle: {
        "margin-bottom": "5px",
        "margin-left": "-100px",
        "margin-top": "10px"
      },
      attrs: {
        "span": 24
      }
    }, [_vm._v("Breve descripción*")]), _vm._v(" "), _c('el-form-item', [_c('el-col', {
      staticStyle: {
        "margin-left": "-120px"
      },
      attrs: {
        "span": 12
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "400px"
      },
      attrs: {
        "placeholder": "Breve Descripcion"
      },
      model: {
        value: (_vm.document.hesDescription[index]),
        callback: function($$v) {
          _vm.$set(_vm.document.hesDescription, index, $$v)
        },
        expression: "document.hesDescription[index]"
      }
    })], 1)], 1), _vm._v(" "), (_vm.document.ocType !== '') ? _c('el-form-item', {
      staticClass: "form-upload",
      attrs: {
        "size": "small",
        "label": ""
      }
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('p', {
      staticStyle: {
        "margin-left": "-65px",
        "margin-top": "10px"
      }
    }, [_vm._v("Adjuntar Documento")])]), _vm._v(" "), _c('el-col', {
      staticClass: "form-pdf",
      staticStyle: {
        "margin-left": "-65px"
      }
    }, [_c('pdf-file', {
      attrs: {
        "pdfFilePath": _vm.document.hesFile[index],
        "habModificaPdf": _vm.habModificaPdf,
        "id": "documento"
      },
      on: {
        "update:pdfFilePath": function($event) {
          return _vm.$set(_vm.document.hesFile, index, $event)
        },
        "update:pdf-file-path": function($event) {
          return _vm.$set(_vm.document.hesFile, index, $event)
        }
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-bottom": "-20px"
      }
    })], 1)], 1) : _vm._e()
  }), _vm._v(" "), (_vm.document.ocType === '2') ? _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "size": "small"
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "input-view1-text",
    attrs: {
      "span": 12
    }
  }, [_vm._v("\n                        Agregar MIGO\n                    ")]), _vm._v(" "), _c('el-col', {
    staticClass: "input-view2",
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "-10px"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.addMigoNumber
    }
  }, [_vm._v("+")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.document.ocType === '2') ? _c('el-divider') : _vm._e(), _vm._v(" "), _vm._l((_vm.document.migoNumbers), function(ocNumber, index) {
    return (_vm.document.ocType === '2') ? _c('el-form-item', {
      key: index,
      staticClass: "form-input",
      attrs: {
        "size": "small"
      }
    }, [_c('el-row', {
      staticStyle: {
        "margin-bottom": "10px",
        "margin-left": "-100px"
      },
      attrs: {
        "span": 24
      }
    }, [_c('b', [_vm._v("Carga de MIGO " + _vm._s(index + 1))])]), _vm._v(" "), _c('el-row', [_c('el-col', {
      staticClass: "input-view1",
      staticStyle: {
        "margin-left": "-120px"
      },
      attrs: {
        "span": 12
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Numero de MIGO*"
      },
      model: {
        value: (_vm.document.migoNumbers[index]),
        callback: function($$v) {
          _vm.$set(_vm.document.migoNumbers, index, $$v)
        },
        expression: "document.migoNumbers[index]"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticClass: "input-view2",
      attrs: {
        "span": 12
      }
    }, [_c('el-button', {
      staticStyle: {
        "margin-left": "35px"
      },
      attrs: {
        "type": "warning"
      },
      on: {
        "click": function($event) {
          return _vm.deleteMigoNumber(index)
        }
      }
    }, [_vm._v("-")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-row', {
      staticStyle: {
        "margin-bottom": "5px",
        "margin-left": "-100px",
        "margin-top": "10px"
      },
      attrs: {
        "span": 24
      }
    }, [_vm._v("Breve descripción*")]), _vm._v(" "), _c('el-form-item', [_c('el-col', {
      staticStyle: {
        "margin-left": "-120px"
      },
      attrs: {
        "span": 12
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "400px"
      },
      attrs: {
        "placeholder": "Breve Descripcion"
      },
      model: {
        value: (_vm.document.migoDescription[index]),
        callback: function($$v) {
          _vm.$set(_vm.document.migoDescription, index, $$v)
        },
        expression: "document.migoDescription[index]"
      }
    })], 1)], 1), _vm._v(" "), (_vm.document.ocType !== '') ? _c('el-form-item', {
      staticClass: "form-upload",
      attrs: {
        "size": "small",
        "label": ""
      }
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('p', {
      staticStyle: {
        "margin-left": "-65px",
        "margin-top": "10px"
      }
    }, [_vm._v("Adjuntar Documento")])]), _vm._v(" "), _c('el-col', {
      staticClass: "form-pdf",
      staticStyle: {
        "margin-left": "-65px"
      }
    }, [_c('pdf-file', {
      attrs: {
        "pdfFilePath": _vm.document.migoFile[index],
        "habModificaPdf": _vm.habModificaPdf,
        "id": "documento",
        "prop": "documento"
      },
      on: {
        "update:pdfFilePath": function($event) {
          return _vm.$set(_vm.document.migoFile, index, $event)
        },
        "update:pdf-file-path": function($event) {
          return _vm.$set(_vm.document.migoFile, index, $event)
        }
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-bottom": "-20px"
      }
    })], 1)], 1) : _vm._e()
  })], 2), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.saveOperationData
    }
  }, [_vm._v("\n            Guardar\n        ")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "info",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("\n            Cancelar\n        ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b82f5b46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/UploadOrder.vue
// module id = 649
// module chunks = 1